/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MasterReserveResponseDto } from './MasterReserveResponseDto';
import {
    MasterReserveResponseDtoFromJSON,
    MasterReserveResponseDtoFromJSONTyped,
    MasterReserveResponseDtoToJSON,
    MasterReserveResponseDtoToJSONTyped,
} from './MasterReserveResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface MasterReserveListResponseDto
 */
export interface MasterReserveListResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof MasterReserveListResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<MasterReserveResponseDto>}
     * @memberof MasterReserveListResponseDto
     */
    items: Array<MasterReserveResponseDto>;
}

/**
 * Check if a given object implements the MasterReserveListResponseDto interface.
 */
export function instanceOfMasterReserveListResponseDto(value: object): value is MasterReserveListResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function MasterReserveListResponseDtoFromJSON(json: any): MasterReserveListResponseDto {
    return MasterReserveListResponseDtoFromJSONTyped(json, false);
}

export function MasterReserveListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MasterReserveListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(MasterReserveResponseDtoFromJSON)),
    };
}

export function MasterReserveListResponseDtoToJSON(json: any): MasterReserveListResponseDto {
    return MasterReserveListResponseDtoToJSONTyped(json, false);
}

export function MasterReserveListResponseDtoToJSONTyped(value?: MasterReserveListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(MasterReserveResponseDtoToJSON)),
    };
}

